import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AppscriptsVoiceCallsFilter } from '../../../shared/models/appscripts-sms.model';
import { AppscriptsCliFilterComponent } from '../appscripts-cli-filter/appscripts-cli-filter.component';
import { AppscriptsCliTableComponent } from '../appscripts-cli-table/appscripts-cli-table.component';

@Component({
  standalone: false,
  selector: 'app-appscripts-cli-index',
  templateUrl: './appscripts-cli-index.component.html',
  styleUrls: ['./appscripts-cli-index.component.scss'],
})
export class AppscriptsCliIndexComponent implements AfterViewInit {
  @ViewChild(AppscriptsCliFilterComponent, { static: false }) filter: AppscriptsCliFilterComponent;
  @ViewChild(AppscriptsCliTableComponent, { static: false }) appscriptsCliTableComponent: AppscriptsCliTableComponent;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title
  ) {
    titleService.setTitle('CLI');
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe(params => {
      if (params.phonenumber) {
        this.filter.form.get('phoneNumbers').setValue(params.phonenumber);
      }
      this.filter.onSubmitClick();
    });
  }

  onSubmitSearchForm(event: AppscriptsVoiceCallsFilter) {
    if (this.appscriptsCliTableComponent.loading) {
      return;
    }
    this.appscriptsCliTableComponent.currentPageNumber = 1;
    this.appscriptsCliTableComponent.requestParams.filter = event;
    this.appscriptsCliTableComponent.update();
  }
}
